<template>
    <div
        v-qa="'grid-view-toggle'"
        class="grid-view-toggle"
    >
        <button
            class="button"
            :class="getClassButton(!tableView)"
            type="button"
            @click="tableView = false"
        >
            Grid view

            <img
                :src="iconGridCards"
                class="icon"
                alt="Grid view"
            />
        </button>

        <button
            class="button"
            :class="getClassButton(tableView)"
            type="button"
            @click="tableView = true"
        >
            List view

            <img
                :src="iconGridTable"
                class="icon"
                alt="List view"
            />
        </button>
    </div>
</template>

<script setup lang="ts">
import iconGridCards from '@/assets/icons/grid_cards.svg'
import iconGridTable from '@/assets/icons/grid_table.svg'

const tableView = defineModel<boolean>('tableView', { default: false })

const getClassButton = (isActive: boolean) => ({
    inactive: !isActive,
})
</script>

<style scoped lang="scss">
.grid-view-toggle {
    margin-right: 8px;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    .button {
        display: flex;
        align-items: center;

        &.inactive {
            opacity: 0.5;
        }
    }

    .icon {
        margin: 0 16px 0 8px;
    }
}
</style>
